var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.getLinkName}},[_c('feather-icon',{attrs:{"icon":"Link2Icon","size":"22"}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }